import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import './styles/responsive-shared.css';
import './styles/responsive-landlord.css';
import './styles/responsive-tenant.css';
import Routing from './Routing';

function App() {
  return (
    <Router>
      <div className="App">
        <Routing />
      </div>
    </Router>
  );
}

export default App;
